import {ApiError, HttpError, ValidationApiError} from '../types/ApiError'
import config from '../Constants'

const api = async <T = object>(path: string, payload: object): Promise<T> => {
    const response = await fetch(config.url.API_URL + path, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
        },
        body: JSON.stringify(payload),
    })

    const data = await response.json().catch(() => null)

    if (response.status === 400 && data) {
        throw new ValidationApiError(data.message, response.status, data.code, data.fields || {})
    }

    if (response.status !== 200 && response.status !== 201) {
        if (data?.message) {
            throw new ApiError(data.message, response.status, data.code)
        }

        throw new HttpError('Failed to complete API request', response.status)
    }

    return data
}

export default api
